module.exports = __webpack_public_path__ + "img/mic.daef5ba8.svg";